const endPoint = "https://vip-main.herokuapp.com/api/v1";

export default endPoint;
